import { API } from '../Auth';

const BASE = '/api/admin/cloud-accounts';

const listCloudAccounts = async () => {
  const response = await API.get('api', BASE);
  return response;
};

const createCloudAccount = async (payload) => {
  try {
    const response = await API.post('api', BASE, { body: payload });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data || error.message);
  }
};

const updateCloudAccount = async (id, payload) => {
  try {
    const response = await API.put('api', `${BASE}/${id}`, { body: payload });
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data || error.message);
  }
};

const deleteCloudAccount = async (id) => {
  try {
    const response = await API.del('api', `${BASE}/${id}`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data || error.message);
  }
};

const testCloudAccount = async (id) => {
  try {
    const response = await API.post('api', `${BASE}/${id}/test`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data || error.message);
  }
};

// Minimal {id, displayName, cloud} list of enabled Alternate Credentials. Available to any
// authenticated user (admin-only endpoints would exclude regular data-source authors).
const pickerCloudAccounts = async () => {
  try {
    const response = await API.get('api', `${BASE}/picker`);
    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.response?.data || error.message);
  }
};

export {
  listCloudAccounts,
  createCloudAccount,
  updateCloudAccount,
  deleteCloudAccount,
  testCloudAccount,
  pickerCloudAccounts
};
